// extracted by css-extract-rspack-plugin
export default {"wrapper":"_872526cc","content":"_62b1b816","title":"_73d1827f","closeButton":"_dfcf0b3f"};